// Written in this round about way for babel-transform-imports
import MemoryRouter from 'react-router/es/MemoryRouter';

export default MemoryRouter;


//////////////////
// WEBPACK FOOTER
// ../~/react-router-dom/es/MemoryRouter.js
// module id = 1110
// module chunks = 0